export default {"src":"/_next/static/media/trend-up.2470ef45.svg","height":25,"width":25};